<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'babel-polyfill';

export default {
  name: 'App',
  mounted() {
      function checkIE() {
          return (
              "-ms-scroll-limit" in document.documentElement.style &&
              "-ms-ime-align" in document.documentElement.style
          );
      }
      if (checkIE()) {
          window.addEventListener(
              "hashchange",
              () => {
                  var currentPath = window.location.hash.slice(1);
                  if (this.$route.path !== currentPath) {
                      this.$router.push(currentPath);
                  }
              },
              false
          );
      }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue